/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect"
export default {
    name: "fileSharePopup",
    components: {

    },
    props: {

        list: {
            type: String,
            default: "",
        },
        source:
        {
            type: String,
            default: "",
        },
        projectId: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            roleList: [],
            permissionset: [],
            dataforsave: {
                "folderId": store.getters.getselectedFolder,
                "userPermission": []
            },
            userobject: {},
            multiuserobject: {},
            permissionList: [],
            selectedscreens: [],
            screensds: [],
            screenNames: [],
            controlName: [],
            baseApi: `${process.env.VUE_APP_Service_URL}`,
            baseurl: `${process.env.VUE_APP_Service_URL}document/folderfilepermission/`,
            baseapi: `${process.env.VUE_APP_Service_URL}configuration`,
            docurl: `${process.env.VUE_APP_Service_URL}document/document/`,
            userList: [],
            // designationList: [],
            closemodal: false,
            selectedRole: [],
            Designation: [],
            selectedValue: [],
            folderPermissionList: [],
            permUserlist: [],
            permUser: "",
            showSave: false,
            fromPage: "",
            versionId: ""
        }
    },
    watch: {
        "$store.getters.getselectedFolder": function (val) {
            this.docId = store.getters.getselectedFolder
        },
    },
    async mounted() {
        this.idtoken = store.getters.getToken
        await this.ScreenRoles();
        this.fromPage = store.getters.getFromPage;
        this.getDocumentdetails();
        document.body.style.overflow = "hidden"
    },
    async unmounted() {
        document.body.style.overflow = "auto"
    },
    methods: {
        ScreenRoles() {
            const fromPage = store.getters.getFromPage;
            if (fromPage == "Department" || fromPage == "generalFiles") {
                this.getalldesignation()
            }
            else {
                this.ListRoles()
            }
        },
        async getalldesignation() {
            await axios
                .get(`${this.baseapi}/designation/search?PageSize=10000&SortProperty=displayName`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.roleList = res.data.entities;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async ListRoles() {
            this.projId = await store.getters.getSelectedProject,
                console.log("SourceType2", this.source)
            await axios
                .get(
                    `${this.baseApi}configuration/projectrole/getall?projectId=${this.projId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.roleList = res.data;
                })
                .catch((err) => {
                    console.log(err);
                    this.roleList = []
                })
        },
        async onChange(event) {
            this.showSave = true
            this.selectedRole = event.target.value;
            await this.SelectBothRoleUsers(this.selectedRole);
            this.permissionset = [];
        },
        async SelectBothRoleUsers(role) {
            const fromPage = store.getters.getFromPage;
            if (fromPage == "Department" || fromPage == 'generalFiles') {
                await this.getDesignationUsers();
            } else {
                await this.getProjectRoleUsers();
            }

        },
        async getDesignationUsers() {
            const idtoken = store.getters.getToken
            const fromPage = store.getters.getFromPage;
            this.selectedValue = this.selectedRole;
            if (fromPage == 'generalFiles') {
                store.dispatch("setMainDepartment", '')
            }
            await axios
                .post(`${this.baseurl}designationusers?departmentId=` + store.getters.getMainDepartment, [this.selectedValue], {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    this.userList = res.data;
                    this.getAllFilePermission();
                    this.setusersinarray();
                    this.getFilePermissionbyId();

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async BothfileMultiSave() {
            const fromPage = store.getters.getFromPage;
            if (fromPage == "Department" || fromPage == 'generalFiles') {
                this.deptfileMultiSave();
            }
            else {
                this.fileMultiSave();
            }

        },
        async deptfileMultiSave() {
            let savedata = {
                "documentId": this.list,
                "version": this.versionId,
                "type": this.source,
                "department":
                    this.projectId,

                "userlist": Object.values(this.userobject)
            };
            await axios
                .post(`${this.baseApi}document/document/share`
                    , savedata, {
                    headers: {
                        Authorization: "Bearer " + this.idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    this.userListsss = res.data;
                    alert("Document shared successfully");
                    this.close();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async fileMultiSave() {
            let projId = store.getters.getSelectedProject;
            const folderId = store.getters.getselectedid
            let savedata = {
                "documentId": folderId,
                "type": this.source,
                "version": this.versionId,
                "department":
                    projId,

                "userlist": Object.values(this.userobject)
            };
            await axios
                .post(`${this.baseApi}document/document/share`
                    , savedata, {
                    headers: {
                        Authorization: "Bearer " + this.idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    this.userListsss = res.data;
                    alert("Document shared successfully");
                    this.close();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // async compareAndSave(existingData, saveData) {
        //     const updatedUsers = [];

        //     // Loop through each user in saveData
        //     for (const user of saveData.userlist) {
        //       // Find the matching user in existingData
        //       const existingUser = existingData.find(
        //         (u) => u.emailId === user.emailId && u.userId === u.userId
        //       );

        //       // If the user doesn't exist in existingData, check if the permission array is empty and skip to the next user
        //       if (!existingUser) {
        //         if (user.permission.length === 0) {
        //           continue;
        //         } else {
        //           // If the permission array is not empty, add the user to updatedUsers
        //           updatedUsers.push(user);
        //         }
        //       } else {
        //         // Compare the permissions
        //         const hasChanges = JSON.stringify(existingUser.permission) !== JSON.stringify(user.permission);

        //         // If there are changes, add the user data to updatedUsers
        //         if (hasChanges) {
        //           updatedUsers.push({
        //             emailId: user.emailId,
        //             userId: user.userId,
        //             permission: user.permission,
        //           });
        //         }
        //       }
        //     }

        //     console.log("updatedUsers",updatedUsers)
        //     return updatedUsers;
        //   },
        async getProjectRoleUsers(value) {
            this.selectedValue = this.selectedRole;
            await axios
                .post(`${this.baseapi}/userprojectrole/getusersbyrole?projectId=${this.projId}`, [this.selectedValue], {
                    headers: {
                        Authorization: "Bearer " + this.idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    this.userList = res.data;
                    this.getAllFilePermission();
                    this.setusersinarray();
                    this.getFilePermissionbyId();

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async clearall() {
            this.selectedscreens = [];
            document.getElementById("selectall").checked = false;
            this.screensds = [];
            await this.screens.forEach((element) => {
                document.getElementById(element.id).checked = false;
                let savescreen = {
                    name: "",
                    controls: [],
                };
                savescreen.name = element.name;
                this.screensds.push(savescreen);
            });
        },
        async setusersinarray() {
            this.userobject = [];
            this.userList.forEach((eachusers) => {
                let userinformations = {
                    "permissionType": "ProjectRole",
                    "permissionId": this.selectedValue,
                    "userId": eachusers.userId,
                    "emailId": eachusers.emailId,
                    "name": eachusers.userName,
                    "permission": []
                };
                this.userobject[eachusers.userId] = userinformations;

            });
        },
        async saveallfun() {
            const usersaveValues = Object.values(this.userobject);
        },
        async setcontrols(elements) {
            let checkBox = document.getElementById(elements.userId);
            if (checkBox.checked == true) {
                this.userobject[elements.userId].permission = this.permissionset;
                console.log("permmm", this.permissionset)

            } else {
                if (elements.userId in this.userobject) {
                    this.userobject[elements.userId].permission = [];
                }
            }
        },
        async setpermissions(permission) {
            let permissioncheckBox = document.getElementById(permission);
            if (permissioncheckBox.checked == true) {
                this.userList.forEach((users) => {
                    if (!this.userobject[users.userId].permission.includes(permission)) {
                        this.userobject[users.userId].permission.push(permission);
                    }
                })
            } else {
                this.userList.forEach((users) => {
                    if (this.userobject[users.userId].permission.includes(permission)) {
                        var index = this.userobject[users.userId].permission.indexOf(permission);
                        if (index !== -1) {
                            this.userobject[users.userId].permission.splice(index, 1);
                        }
                    }
                })
            }
        },
        async selectall() {
            let checkBoxall = document.getElementById("selectall");
            if (checkBoxall.checked == true) {
                this.userList.forEach((users) => {
                    this.userobject[users.userId].permission = this.permissionset;
                })
            } else {
                this.userList.forEach((users) => {
                    this.userobject[users.userId].permission = [];
                })
            }
        },
        // async getallpermissions() {
        //     const fromPage = store.getters.getFromPage;
        //     if (fromPage == "Department") {
        //         await this.getAllFilePermission();
        //     }
        //     else {
        //         await this.getAllFolderPermission();
        //     }

        // },

        async getAllFilePermission() {
            await axios
                .get(`${this.baseurl}allfilepermission`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    })
                .then((res) => {
                    this.permissionList = res.data;

                    this.setofpermissions();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        setofpermissions() {
            this.permissionList.forEach((permissions) => {
                this.permissionset.push(permissions.permission);
            })
        },
        selectuserwithpermission(userid) {
            let checkBox = "";
            console.log("enter checkbox")
            checkBox = document.getElementById(userid);
            if ((this.userobject[userid].permission).length != 0) {
                checkBox.checked = true;
            }
        },
        async getDocumentdetails() {
            await axios
                .get(
                    `${this.docurl}getdocumentdetails?documentId=${this.list}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.versionId = res.data.latestVersion;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async getFilePermissionbyId() {
            await axios
                .post(`${this.baseurl}getfilepermission?documentId=${this.list}`, [this.selectedValue],
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json",
                        },
                    })
                .then((res) => {
                    this.folderPermissionList = res.data;
                    this.retrievePermission();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async retrievePermission() {
            await this.folderPermissionList.forEach((element) => {
                this.userobject[element.userId].permission = element.permission;
            });
        },

        close() {
            this.$emit('closemodal')
            store.dispatch("setfileType", '')
        }
    }
}
